import React from 'react';
import {LanguageDeclareType} from './types';

export const Jp: LanguageDeclareType = {
	$$settings: {
		code: 'jp',
		name: '日本語',
		fallback: ''
	},
	// fix key, anything under PLAIN will not be proxy to other type
	// anything must be string, should be placed here.
	// such as input tooltip(string property), tuple name(not for react component)
	PLAIN: {
		CONSOLE_SEARCH_PLACEHOLDER: '連結空間、主題、レポート、ダッシュボードを検索します...',
		NEW_DASHBOARD_NAME: 'ダッシュボード',
		DEFAULT_DASHBOARD_NAME: 'ダッシュボード',
		NEW_CONNECTED_SPACE_NAME: '連結空間',
		DEFAULT_CONNECTED_SPACE_NAME: '連結空間',
		NEW_SUBJECT_NAME: '主題',
		DEFAULT_SUBJECT_NAME: '主題',
		NEW_REPORT_NAME: 'レポート',
		DEFAULT_REPORT_NAME: 'レポート',
		CONSTANT_INPUT_PLACEHOLDER: '定数値を入力してください...',
		UNKNOWN_TOPIC_NAME: '不明なトピック',
		UNKNOWN_FACTOR_NAME: '不明なファクター',
		REPORT_DESCRIPTION_PLACEHOLDER: '説明を入力してください...',
		LOADING: '読み込み中...',
		FIND_INDICATOR_PLACEHOLDER: '指標名 説明に基づいて検索します。',
		FIND_TOPIC_OR_FACTOR_OR_SUBJECT_PLACEHOLDER: 'トピック名またはファクター名または主題名に基づいて検索します。',
		INDICATOR_NAME_PLACEHOLDER: '読むための名前を入力してください。',
		INDICATOR_DESCRIPTION_PLACEHOLDER: '指標の説明を入力してください。',
		FIND_BUCKET_PLACEHOLDER: 'バケット名 説明に基づいて検索します。',
		BUCKET_CATEGORY_SEGMENT_VALUE_PLACEHOLDER: '分類値、セグメントに追加することを確認します。',
		FIND_INDICATOR_VALUE_BUCKETS_PLACEHOLDER: 'バケット名に基づいて検索します。',
		FIND_OBJECTIVE_PLACEHOLDER: '目標名 説明に基づいて検索します。',
		FIND_CONVERGENCE_PLACEHOLDER: '収束名 説明に基づいて検索します。',
		OBJECTIVE_NAME_PLACEHOLDER: '読むための名前を入力してください。',
		OBJECTIVE_DESCRIPTION_PLACEHOLDER: '目標の説明を入力してください。',
		OBJECTIVE_VARIABLE_NAME_PLACEHOLDER: '変数名。',
		OBJECTIVE_FACTOR_NAME_PLACEHOLDER: '指標名。',
		OBJECTIVE_FORMULA_CONSTANT_PLACEHOLDER: '定義済みの変数を参照するには、"{}" を使用します。',
		OBJECTIVE_FACTOR_FILTER_CONSTANT_PLACEHOLDER: '定義済みの変数を参照するには、"{}" を使用します。',
		SUBSCRIBE_MAIL_ADDRESS_PLACEHOLDER: '";"で結合された複数のアドレス。',
		NEW_DERIVED_OBJECTIVE_NAME: '目標',
		DEFAULT_DERIVED_OBJECTIVE_NAME: '目標',
		NEW_DERIVED_OBJECTIVE_TARGET_BREAKDOWN_NAME: '内訳',
		CONVERGENCE_NAME_PLACEHOLDER: '読むための名前を入力してください。',
		CONVERGENCE_DESCRIPTION_PLACEHOLDER: '収束の説明を入力してください。',
		CONVERGENCE_FREEWALK_VALUE_PLACEHOLDER: 'セグメントを分割するには「;」を使用してください。'
	},
	STANDARD: {
		YES: 'はい',
		NO: 'いいえ'
	},
	ERROR: {
		UNAUTHORIZED: '権限がありません。ログインしてください。',
		ACCESS_DENIED: 'アクセスが拒否されました。詳細については、管理者にお問い合わせください。',
		UNPREDICTED: '未知のエラーが発生しました。詳細については、管理者にお問い合わせください。'
	},
	ALERT: {
		BUTTON: '取得',
		NOT_IMPLEMENT: '該当機能はまだ実装されていません。'
	},
	DIALOG: {
		BUTTON_YES: 'はい',
		BUTTON_NO: 'いいえ'
	},
	ACTIONS: {
		SAVE: '保存します',
		COPY: 'コピー',
		CLOSE: '閉じる',
		CANCEL: '取消',
		DELETE: '削除',
		REMOVE: '削除',
		CONFIRM: '確認',
		NEXT: '次へ',
		SORT_ASC: '昇順',
		SORT_DESC: '降順',
		PREVIOUS_PAGE: '前へ',
		NEXT_PAGE: '次へ',
		EXPAND: '展開じる',
		COLLAPSE: '閉じる',
		MINIMIZE: '最小化する',
		MAXIMIZE: '最大化する',
		RESTORE: '戻す',
		SUBSCRIBE: '購読'
	},
	LOGIN: {
		PRODUCT_TITLE: <>Indexical Metrics <span>&</span> Measure Advisory</>,
		MORNING: 'おはようございます ！',
		AFTERNOON: 'こんにちは ！',
		EVENING: 'こんばんは ！',
		BUTTON: 'ログイン ！',
		NAME_EMPTY: 'アカウントを入力してください。',
		CREDENTIAL_EMPTY: 'パスワードを入力してください。',
		FAIL: 'アカウントまたはパスワードの認証に失敗しました。'
	},
	ADMIN: {
		UNKNOWN_USER_GROUP: '不明なユーザー グループ',
		NONAME_USER_GROUP: '名前のないユーザー グループ'
	},
	DATASET: {
		UNFIX_COLUMN: 'これ以降のカラムの固定を解除すうｒ',
		FIX_COLUMN: 'このカラムに固定する',
		COMPRESS_COLUMNS: 'カラムの幅を狭める',
		DOWNLOAD_PAGE: 'このページをダウンロードする',
		DOWNLOAD_ALL: 'すべてをダウンロードする',
		SIMULATE_DATA: 'シミュレート',
		UPLOAD_DATA: 'データをアップロードする',
		UPLOAD_DATA_FAILURE: 'データのアップロードに失敗しました、データ形式を確認してください。',
		DOWNLOAD_TEMPLATE: 'テンプレートのダウンロード'
	},
	CONSOLE: {
		LOADING: '個人データ読み込み中...',
		BYE: '終了しますか？',
		ERROR: {
			DASHBOARD_NOT_FOUND: '該当ダッシュボードが見つかりません。',
			CONNECTED_SPACE_NOT_FOUND: '該当連結空間が見つかりません。',
			DERIVED_OBJECTIVE_NOT_FOUND: '該当目標が見つかりません。',
			SUBJECT_NOT_FOUND: '該当主題が見つかりません。',
			REPORT_NOT_FOUND: '該当レポートが見つかりません。'
		},
		MENU: {
			TITLE: 'Watchmenコンソール',
			HOME: 'ホーム',
			DASHBOARDS: 'ダッシュボード',
			FAVORITE: 'お気に入りを表示する',
			CONNECT_SPACE: '連結空間に接続',
			SETTINGS: '設定',
			TO_CONSOLE: 'ワークベンチに切り替える',
			TO_ADMIN: '管理者に切り替える',
			TO_DATA_QUALITY: 'データ品質センターに切り替える',
			TO_INDICATOR: '指標ーワークベンチに切り替える',
			LOGOUT: 'ログアウト'
		},
		FAVORITE: {
			TITLE: 'お気に入り',
			NO_DATA: 'お気に入りのアイテムはありません。',
			PIN: '固定',
			UNPIN: '固定を解除する'
		},
		HOME: {
			TITLE: 'ホーム',
			SORT_BY_NAME: '名前で並べ替え',
			SORT_BY_VISIT_TIME: '訪問時間で並べ替え',
			VIEW_COLLAPSE: '折りたたむ',
			VIEW_ALL: '表示',
			CONNECTED_SPACE_TITLE: '最近使用した連結空間',
			CREATE_CONNECTED_SPACE_BUTTON: '連結空間に接続',
			DERIVED_OBJECTIVE_TITLE: '最近使用した目標',
			CREATE_DERIVED_OBJECTIVE_BUTTON: '目標を作成する',
			DASHBOARD_TITLE: '最近使用したダッシュボード',
			CREATE_DASHBOARD_BUTTON: 'ダッシュボードを作成する',
			NO_RECENT: '最近使用した項目はありません。'
		},
		DASHBOARD: {
			SHARE: '共有',
			PRINT: '印刷',
			REFRESH: '更新',
			AUTO_REFRESH: '自動更新(5分間隔)',
			ADD_INTO_FAVORITE: 'お気に入りに追加',
			REMOVE_FROM_FAVORITE: 'お気に入りから削除',
			ADD_REPORT: 'レポートを追加する',
			ADD_PARAGRAPH: 'コメントを追加する',
			ADD_DASHBOARD: 'ダッシュボードを追加する',
			SWITCH_DASHBOARD: 'ダッシュボードを切り替える',
			DELETE_ME: '削除',
			SHARE_DIALOG_LABEL: 'URLをコピーして共有する。',
			URL_COPIED: 'URLをコピーしました。',
			DELETE_DIALOG_LABEL: 'ダッシュボードを削除してもよろしいですか？ 削除したものは復元できませんので、ご注意ください。',
			NO_MORE_DASHBOARD: 'これ以上のダッシュボードは存在しません。',
			SWITCH_DIALOG_LABEL: 'ダッシュボードを選択してください',
			NO_MORE_REPORT: 'これ以上のレポートはありません。',
			DELETE_REPORT_DIALOG_LABEL: 'レポートを削除してもよろしいですか？ 削除したものは復元できませんので、ご注意ください。',
			DELETE_PARAGRAPH_DIALOG_LABEL: 'コメントを削除してもよろしいですか？ 削除したものは復元できませんので、ご注意ください。',
			NO_REPORT: 'レポートは定義されていません。',
			SHOW_PRINT_PAGE: 'ページサイズを表示する',
			HIDE_PRINT_PAGE: 'ページサイズを非表示する',
			SET_AS_ADMIN_HOME: '管理者ホームとして設定する',
			FUNNEL_TITLE: 'データフォーカス'
		},
		CONNECTED_SPACE: {
			CATALOG: 'カタログ',
			SUBJECT_DEF: '主題を定義する',
			SUBJECT_DATA: 'データセット',
			SUBJECT_REPORTS: 'レポート一覧',
			SUBJECT_REPORT: 'レポート',
			REPORT_DATA: 'データセット',
			REPORT_FILTER: 'フィルタ',
			REPORT_FUNNEL: 'じょうご',
			SHARE: '共有',
			ADD_REPORT: 'レポートを追加する',
			ADD_SUBJECT: '主題を追加する',
			OPEN_SUBJECT: '主題を開く',
			ADD_CONNECTED_SPACE: '連結空間に接続',
			SWITCH_CONNECTED_SPACE: '接続された連結空間に切り替える',
			DELETE_ME: '削除',
			ADD_INTO_FAVORITE: 'お気に入りに追加',
			REMOVE_FROM_FAVORITE: 'お気に入りから削除',
			SET_AS_TEMPLATE: 'テンプレートとして設定',
			REMOVE_FROM_TEMPLATE: 'テンプレートから削除',
			DELETE_DIALOG_LABEL: '連結空間を削除してもよろしいですか？ 削除したものは復元できませんので、ご注意ください。',
			NO_MORE_CONNECTED_SPACE: 'これ以上の接続された連結空間は存在しません。',
			SWITCH_DIALOG_LABEL: '接続された連結空間を選択してください',
			CREATE_DIALOG_LABEL: '利用可能な連結空間を選択してください',
			CREATE_DIALOG_CHOOSE_TEMPLATE_LABEL: '好きなテンプレートを選択してください',
			TEMPLATE: 'テンプレート',
			TEMPLATE_CREATE_BY: '著者',
			NO_MORE_SPACE: '連結空間がありません。詳細については、管理者に問い合わせてください。',
			SPACE_NOT_FOUND: '連結空間の定義が見つかりません。詳細については、管理者に問い合わせてください。',
			TOPICS_NOT_FOUND: 'トピックの定義が見つかりません。詳細については、管理者に問い合わせてください。',
			TOPICS_COUNT_MISMATCH: 'トピック数は一致していません。詳細については、管理者に問い合わせてください。',
			TOPIC_WITH_NO_FACTOR: 'ファクターは定義されていません。詳細については、管理者に問い合わせてください。',
			DELETE_SUBJECT_DIALOG_LABEL: '主題を削除してもよろしいですか？ 削除したものは復元できませんので、ご注意ください。',
			SWITCH_SUBJECT: '主題を切り替える',
			SWITCH_SUBJECT_DIALOG_LABEL: '主題を選択してください',
			NO_MORE_SUBJECT: 'これ以上の主題は存在しません。',
			SUBJECT_DEF_INVALID: '主題の定義に誤りがあります。確認してください。',
			SUBJECT_PICK_TOPICS: 'トピックを選択する',
			SUBJECT_DEFINE_COLUMNS: 'カラムを定義する',
			SUBJECT_FILTER_DATA: 'データフィルタ',
			SUBJECT_SET_JOINS: 'データ結合を設定する',
			SUBJECT_DEF_OVERVIEW: '一覧',
			NO_PICKED_TOPIC_FOR_SUBJECT: '選択されたトピックはありません。',
			NO_DATASET_COLUMN_FOR_SUBJECT: 'カラムは定義されていません。定義しますか',
			CREATE_DATASET_COLUMN_WHEN_NONE: '始める',
			NO_DATASET_COLUMN_FOR_SUBJECT_2: 'か？',
			ALIAS: 'カラム名',
			SUBJECT_COLUMN_ARITHMETIC: '集計方法',
			SUBJECT_COLUMN_ARITHMETIC_NONE: 'そのまま',
			SUBJECT_COLUMN_ARITHMETIC_COUNT: '数量',
			SUBJECT_COLUMN_ARITHMETIC_DISTINCT_COUNT: '合計数の重複排除',
			SUBJECT_COLUMN_ARITHMETIC_SUMMARY: '合計',
			SUBJECT_COLUMN_ARITHMETIC_AVERAGE: '平均値',
			SUBJECT_COLUMN_ARITHMETIC_MAX: '最大値',
			SUBJECT_COLUMN_ARITHMETIC_MIN: '最小値',
			SUBJECT_COLUMN_RENDERER_ALIGNMENT: '对齐',
			SUBJECT_COLUMN_RENDERER_ALIGNMENT_LEFT: '左揃え',
			SUBJECT_COLUMN_RENDERER_ALIGNMENT_CENTER: '中央揃え',
			SUBJECT_COLUMN_RENDERER_ALIGNMENT_RIGHT: '右揃え',
			SUBJECT_COLUMN_RENDERER_FORMAT: 'アラインメント',
			SUBJECT_COLUMN_RENDERER_FORMAT_NONE: 'なし',
			SUBJECT_COLUMN_RENDERER_HIGHLIGHT_NEGATIVE: '負の値を強調表示',
			SUBJECT_COLUMN_POSITION_ALREADY_AT_FIRST: 'すでに上にいるため、上に移動できません。',
			SUBJECT_COLUMN_POSITION_ALREADY_AT_LAST: 'すでに底にあるため、下に移動できません。',
			ADD_SUBJECT_COLUMN: 'カラムを追加',
			ADD_SUBJECT_RECALCULATE_COLUMN: '再計算列を追加',
			CAN_NOT_DELETE_CHILD_FROM_COMPUTED: 'パラメータ数の最小限に達したため、削除できません。',
			CAN_NOT_ADD_CHILD_INTO_COMPUTED: 'パラメータ数の最大限に達したため、これ以上追加できません。',
			ADD_COMPUTE_PARAMETER: 'パラメータを追加する',
			NO_DATASET_FILTER_FOR_SUBJECT: 'フィルタは定義されていません。定義しますか',
			CREATE_DATASET_FILTER_WHEN_NONE: '始める',
			NO_DATASET_FILTER_FOR_SUBJECT_2: 'か？',
			ADD_SUB_EXPRESSION_FILTER: 'フィルタの条件を追加',
			ADD_SUB_JOINT_FILTER: 'サブ結合を追加',
			NO_DATASET_JOIN_FOR_SUBJECT: '結合は定義されていません。定義しますか',
			CREATE_DATASET_JOIN_WHEN_NONE: '始める',
			NO_DATASET_JOIN_FOR_SUBJECT_2: 'か？',
			ADD_SUBJECT_JOIN: '結合を追加する',
			SUBJECT_SELECT: 'Select',
			SUBJECT_NO_SELECT: 'カラムは定義されていません。',
			SUBJECT_FROM: 'From',
			SUBJECT_NO_FROM: '結合は定義されていません。',
			SUBJECT_JOIN_INNER: '内部結合',
			SUBJECT_JOIN_LEFT: '左結合',
			SUBJECT_JOIN_RIGHT: '右結合',
			SUBJECT_JOIN_ON: 'On',
			SUBJECT_JOIN_EQUALS: '=',
			SUBJECT_JOIN_AND: 'And',
			SUBJECT_WHERE: 'Where',
			SUBJECT_NO_WHERE: 'フィルタは定義されていません。',
			SUBJECT_UNKNOWN_PARAMETER: '不明なパラメータ',
			SUBJECT_EMPTY_CONSTANT: '空の定数値',
			SUBJECT_COLUMN_AS: 'As',
			SUBJECT_NO_ALIAS: '？',
			SUBJECT_FILTER_JOINT_NO_STATEMENT: 'ジョイントがありません',
			SUBJECT_UNKNOWN_FILTER: '不明なフィルタ',
			NO_DATASET_COLUMN: 'カラムは定義されていません。',
			NO_REPORT: 'レポートは定義されていません。定義しますか',
			CREATE_REPORT: '始める',
			NO_REPORT_2: 'か？',
			NO_MORE_REPORT: 'これ以上のレポートは存在しません.',
			OPEN_REPORT: 'レポートを開く',
			SWITCH_REPORT: 'レポートを切り替える',
			SWITCH_REPORT_DIALOG_LABEL: 'レポートを選択してください',
			DELETE_REPORT_DIALOG_LABEL: 'レポートを削除してもよろしいですか？ 削除したものは復元できませんので、ご注意ください。',
			COLLAPSE_REPORT_SETTINGS_SECTIONS: 'すべてのセクションを折りたたむ',
			EXPAND_REPORT_SETTINGS_SECTIONS: 'すべてのセクションを表示する',
			REPORT_NO_FILTER: 'フィルタは定義されていません。定義しますか',
			CREATE_REPORT_FILTER: '始める',
			REPORT_NO_FILTER_2: 'か？',
			REPORT_NO_FUNNEL: 'じょうごが有効になっていない。'
		},
		DERIVED_OBJECTIVE: {
			CREATE_DIALOG_CHOOSE_TEMPLATE_LABEL: '目標テンプレートを選択してください',
			TEMPLATE: '目標',
			NO_MORE_OBJECTIVE: '目標テンプレートの定義が見つかりません。詳細については、管理者に問い合わせてください。',
			NO_OBJECTIVE_SELECTED: '目標テンプレートが選択されていません。',
			ADD_INTO_FAVORITE: 'お気に入りに追加',
			REMOVE_FROM_FAVORITE: 'お気に入りから削除',
			ADD_DERIVED_OBJECTIVE: 'テンプレートから目標を作成',
			SWITCH_DERIVED_OBJECTIVE: '目標に切り替える',
			SWITCH_DIALOG_LABEL: '目標を選択してください',
			DELETE_DIALOG_LABEL: '目標を削除してもよろしいですか？ 削除したものは復元できませんので、ご注意ください。',
			DELETE_ME: '削除',
			REFRESH_VALUES: 'リフレッシュ',
			SHOW_VARIABLES: '変数設定を表示',
			HIDE_VARIABLES: '変数設定を非表示',
			UNKNOWN_TARGET_NAME: '不明な目標',
			VARIABLES_TITLE: '条件変数',
			UNKNOWN_VARIABLE_NAME: '不明な変数',
			TIME_FRAME_TITLE: '時間枠',
			NOT_TIME_RELATED: '目標に指定された時間枠がありません。',
			TIME_FRAME_KIND_YEAR: '毎年',
			TIME_FRAME_KIND_HALF_YEAR: '半年ごと',
			TIME_FRAME_KIND_QUARTER: '季刊',
			TIME_FRAME_KIND_MONTH: '毎月',
			TIME_FRAME_KIND_WEEK_OF_YEAR: 'ウィークリー',
			TIME_FRAME_KIND_DAY_OF_MONTH: '毎月、毎日',
			TIME_FRAME_KIND_DAY_OF_WEEK: '毎日',
			TIME_FRAME_KIND_LAST_N_YEARS: '近年',
			TIME_FRAME_KIND_LAST_N_MONTHS: 'ここ数ヶ月',
			TIME_FRAME_KIND_LAST_N_WEEKS: 'ここ数週間',
			TIME_FRAME_KIND_LAST_N_DAYS: '最近の日',
			BREAKDOWN: '内訳',
			HIDE_BREAKDOWN: '内訳を隠す',
			ADD_BREAKDOWN: '内訳の追加',
			REMOVE_BREAKDOWN: '削除',
			DIMENSION_ON_INDICATOR_VALUE: '目標値を使用',
			ADD_FIRST_BREAKDOWN_DIMENSION: 'ディメンションの追加',
			ADD_BREAKDOWN_DIMENSION: 'ディメンションの追加',
			VALUE_AS_DIMENSION: '自然分類を使用',
			ASK_BREAKDOWN_VALUES: 'データを取得',
			BREAKDOWN_NO_DIMENSION: 'ディメンションが定義されていません。',
			FAILED_ON_FETCH_BREAKDOWN_VALUES: 'データを取得できません。詳細については、管理者に問い合わせてください。',
			NO_DATA_FETCHED_BREAKDOWN_VALUES: 'データがありません。',
			SHARE: '共有',
			PRINT: '印刷',
			SHARE_DIALOG_LABEL: 'URLをコピーして共有する。',
			URL_COPIED: 'URLをコピーしました。'
		}
	},
	INDICATOR: {
		MENU: {
			TITLE: 'Watchmen指標',
			BUCKETS: 'バケット',
			INDICATORS: '指標',
			OBJECTIVES: '目標',
			CONVERGENCES: '収束',
			SETTINGS: '設定',
			LOGOUT: 'ログアウト'
		},
		ON_EDIT: '編集中、保存されていないデータはすべて失われます。編集を破棄しますか。',
		STEP: 'ステップ',
		INDICATOR: {
			LIST_TITLE: '指標',
			LIST_CREATE_INDICATOR: '指標を作成',
			LIST_LABEL: '指標',
			NEW_INDICATOR_PREFIX: '新しい',
			EXISTING_INDICATOR_PREFIX: '既存',
			CREATE_AT: '作成先',
			LAST_MODIFIED_AT: '最終更新日',
			TITLE: '指標を準備',
			WAIT_INPUT: '入力を待っている...',
			SEARCHING: '検索中...',
			NO_MATCHED: '一致するデータが見つかりませんでした。',
			OR: 'または',
			CREATE_INDICATOR: '新しい指標を定義します',
			FIND_INDICATOR: '定義された指標を検索します',
			DISCARD_FIND_INDICATOR: '捨てる',
			ON_CREATE_INDICATOR: '新しい指標が定義されています',
			ON_VIEW_INDICATOR: '指標を表示',
			RESTART: '再起動',
			BACK_TO_LIST: 'リストに戻り',
			PICK_TOPIC_OR_SUBJECT: 'トピックまたは主題を選択します',
			DEFINE_ON_TOPIC: 'トピックに対する定義',
			DEFINE_ON_SUBJECT: '主題に対する定義',
			INDICATOR_ON_TOPIC: 'トピックに関する',
			INDICATOR_ON_SUBJECT: '主題に関する',
			FAILED_TO_LOAD_INDICATOR: '指標データの読み込みにエラーが発生しました。詳細については、管理者に問い合わせてください。',
			AGGREGATE_ITEM_TITLE: '集計方法を選択します。',
			MEASURE_METHODS_TITLE: '現在の指標で使用できる測定ディメンションは、自動的に検出されます。',
			FACTOR: 'ファクター',
			FACTOR_NAME: '名前',
			FACTOR_LABEL: 'レベル',
			FACTOR_TYPE: 'タイプ',
			FACTOR_ENUM: '列挙',
			GEO: '地理的に関連しています',
			TIME_PERIOD: '時間範囲',
			INDIVIDUAL: '個人的に',
			ORGANIZATION: '機関',
			CATEGORY: '分類を指定します',
			DEFINE_BUCKETS_TITLE: '分類と集計を改善するための事前定義されたバケット。',
			INDICATOR_VALUE_BUCKET_ONLY_ON_FACTOR_LABEL: '指標値バケットは、データファクタが選択されている場合にのみさらに定義できます',
			INDICATOR_VALUE_BUCKET_LABEL: '指標値はバケットで定義',
			LINK_INDICATOR_VALUE_BUCKETS: '定義済みの指標値のバケットを関連付けます',
			DISCARD_LINK_INDICATOR_VALUE_BUCKETS: '捨てる',
			MEASURE_BUCKET_LABEL: '測定寸法のバケット定義',
			NO_MEASURE_BUCKET: '適切な測定寸法のバケットは見つかりませんでした。',
			VIEW_MEASURE_BUCKETS: '定義済みの測定寸法のバケットを表示します',
			IGNORE_DEFINE_BUCKETS: 'バケット定義を無視する',
			CHANGE_NAME: '名前を変更',
			NOT_NOW: '捨てる',
			SAVE_INDICATOR: '指標を保存',
			SAVE_NAME: '名前を保存',
			REQUIRE_INDICATOR_NAME: '読み取りには指標名が必要です。',
			RELEVANT_TITLE: '現在の指標に関連する指標は、自動的に検出できます。',
			INDICATOR_NAME: '関連指標',
			INDICATOR_RELEVANT_TYPE: '関連性',
			IRRELEVANT: '何の関係もない',
			NO_RELEVANT_DETECTED: '現在、関連指標は検出されていません。',
			DETECT_RELEVANT: '潜在的な関連指標を検出します',
			IGNORE_DETECT_RELEVANT: '今すぐ検出を無視',
			FILTERS_ON_TOPIC: 'データの制限.',
			FILTERS_ON_SUBJECT: 'データ制限は主題で定義されており、現在の指標に適用されます.',
			CATEGORIES_TITLE: 'カテゴリ。',
			DESCRIPTION_TITLE: '説明。',
			LAST_STEP_TITLE: '指標の設定が完了しました。',
			PREPARE_ANOTHER: '別の指標を定義します'
		},
		BUCKET: {
			TITLE: 'バケット',
			LABEL: 'バケット',
			NEW_BUCKET_PREFIX: '新しい',
			EXISTING_BUCKET_PREFIX: '既存',
			CREATE_BUCKET: 'バケットを作成',
			NAME_LABEL: 'バケット名:',
			TYPE_LABEL: 'バケットの種類:',
			TYPE_IS_FIXED_ONCE_SAVE: 'バケットタイプは、バケットが最初に保存された後にロックされ、変更できなくなります。',
			DESCRIPTION_LABEL: '説明:',
			CREATE_AT: '作成先',
			LAST_MODIFIED_AT: '最終更新日',
			BUCKET_NAME_IS_REQUIRED: 'バケット名を記入してください。',
			BUCKET_MEASURE_IS_REQUIRED: '測定寸法を選択してください。',
			BUCKET_ENUM_IS_REQUIRED: '列挙型を選択してください。',
			BUCKET_SEGMENTS_IS_REQUIRED: '少なくとも 2 つのセグメントを定義する必要があります。',
			BUCKET_SEGMENT_NAME_IS_REQUIRED: 'セグメント名を入力してください。',
			BE_NUMERIC_OF_NUMERIC_SEGMENT: 'セグメント値は数値である必要があります。',
			EMPTY_FIRST_MIN_OF_NUMERIC_SEGMENT: '最初のセグメントの最小値を入力しないでください。',
			NOT_EMPTY_FIRST_MAX_OF_NUMERIC_SEGMENT: '最初のセグメントの最大値を入力してください。',
			NOT_EMPTY_OF_NUMERIC_SEGMENT: '中間セグメントのセグメント値を入力してください。',
			MIN_MAX_ORDER_OF_NUMERIC_SEGMENT: 'セグメントの最小値を最大値より小さくしてください。',
			NOT_EMPTY_LAST_MIN_OF_NUMERIC_SEGMENT: '最後のセグメントの最小値を入力してください。',
			EMPTY_LAST_MAX_OF_NUMERIC_SEGMENT: '最後のセグメントの最大値を入力しないでください。',
			RANGE_LACK_EXISTS_OF_NUMERIC_SEGMENT: '数値区間はセグメントで覆う。',
			RANGE_OVERLAP_EXISTS_OF_NUMERIC_SEGMENT: 'セグメント区間が重なる。',
			NOT_EMPTY_OF_CATEGORY_SEGMENT: '少なくとも 1 つの分類値を定義してください。',
			NO_DUPLICATED_OF_CATEGORY_SEGMENT: '同じセグメント内に重複する分類は存在できません。',
			ONE_OTHERS_SEGMENT_OF_CATEGORY_SEGMENT: '分類 (その他) を含めることができるセグメントは 1 つだけです。',
			ONE_OTHERS_VALUE_OF_CATEGORY_SEGMENT: 'セグメント内に含めることができる分類 (その他) は 1 つだけである。',
			NO_SHARED_OF_CATEGORY_SEGMENT: '同じカテゴリを複数のセグメントに存在させてはならない。',
			NO_SEGMENT_DEFINED: '定義されていません',
			ONE_SEGMENT_DEFINED: '1 つの定義',
			N_SEGMENT_DEFINED: 'つの定義',
			BUCKET_TYPE_VALUE: 'バリューバケット',
			BUCKET_TYPE_VALUE_MEASURE: '測定寸法値のバケット',
			BUCKET_TYPE_CATEGORY_MEASURE: '測定寸法値分類のバケット',
			BUCKET_TYPE_ENUM_MEASURE: '測定寸法列挙のバケット',
			RANGE_INCLUDING_LABEL: '値の格納方法:',
			RANGE_INCLUDE_MIN: '[最小値を含み、最大値は含まれません)',
			RANGE_INCLUDE_MAX: '(最小値は含まれ、最大値は含まれません]',
			SEGMENTS_LABEL: 'セグメント定義:',
			SEGMENT_NAME: 'セグメント名',
			VALUE_SEGMENT_MIN_LABEL: '最小値',
			VALUE_SEGMENT_MAX_LABEL: '最大値',
			ADD_SEGMENT: '値のセグメンテーションを追加',
			SORT_SEGMENTS: '並べ替え',
			MEASURE_METHOD_LABEL: '測定寸法:',
			MEASURE_METHOD_IS_FIXED_ONCE_SAVE: '測定寸法は、バケットが最初に保存された後にロックされ、変更できなくなります。',
			CATEGORY_SEGMENT_LABEL: '分類値',
			DUPLICATE_CATEGORY_SEGMENT_VALUE: '分類は既にこのセグメントに存在します。',
			DUPLICATE_CATEGORY_SEGMENT_VALUE_CASE_IGNORED: '分類 (大文字と小文字を区別しない) は、このセグメントに既に存在します。',
			OTHERS_IS_EXCLUSIVE_ON_CATEGORY_SEGMENT: '分類 (その他) は排他的であり、他のカテゴリと同時に存在することはできません。',
			NO_SEGMENT_VALUE_DEFINED: '値が定義されていません',
			ADD_OTHER_CATEGORY: 'その他を追加',
			ENUM_LABEL: '列挙:',
			ENUM_IS_FIXED_ONCE_SAVE: '列挙は、バケットが最初に保存された後にロックされ、変更できなくなります。',
			SORT_SEGMENTS_BY_CODE: 'コードで並べ替え',
			SORT_SEGMENTS_BY_NAME: '名前で並べ替え',
			AVAILABLE_ENUM_ITEMS_LABEL: '使用可能な列挙項目:',
			NO_AVAILABLE_ENUM_ITEMS: '使用できるデータがありません。',
			ADD_AVAILABLE_ITEMS_INTO_SEGMENT: 'セグメントに追加',
			SEGMENT_LABEL: 'セグメント',
			PLEASE_SELECT_SEGMENT: '選択した列挙項目を含むセグメントを選択してください。',
			PLEASE_SELECT_ENUM_ITEM: '少なくとも 1 つの列挙項目を選択してセグメント化に参加してください。'
		},
		OBJECTIVE: {
			LIST_TITLE: '目標',
			LIST_CREATE_OBJECTIVE: '目標を作成',
			LIST_LABEL: '目標',
			NEW_OBJECTIVE_PREFIX: '新しい',
			EXISTING_OBJECTIVE_PREFIX: '既存',
			CREATE_AT: '作成先',
			LAST_MODIFIED_AT: '最終更新日',
			TITLE: '目標を準備',
			FAILED_TO_LOAD_OBJECTIVE: '目標データの読み込みにエラーが発生しました。詳細については、管理者に問い合わせてください。',
			TARGETS_TITLE: '定量的目標値の宣言。',
			BACK_TO_LIST: 'リストに戻り',
			TARGET_NAME: '名前:',
			TARGET_TOBE: '目標値:',
			TARGET_TOBE_PLACEHOLDER: '数値、またはパーセンテージ (% で終了)。',
			TARGET_ASIS: 'そのままの値:',
			TARGET_ASIS_REFER: '指標参照',
			TARGET_ASIS_COMPUTED: '計算式を設定',
			TARGET_BETTER_SIDE: '方向を改善:',
			TARGET_BETTER_SIDE_MORE: '値が大きいほど良い',
			TARGET_BETTER_SIDE_LESS: '値が小さいほど良い',
			TARGET_ASK_PREVIOUS_CYCLE: '以前の期間との比較は含まれていますかd？',
			TARGET_ASK_CHAIN_CYCLE: '前のサイクルの同じ期間と比較されますか？',
			TARGET_VALUES: '値:',
			TARGET_CURRENT_VALUE: '現在',
			TARGET_PREVIOUS_VALUE: 'リング',
			TARGET_CHAIN_VALUE: '同期比',
			TARGET_FINISH_RATE: '完了率',
			ADD_TARGET: '新しい目標を追加',
			TARGET_CONSANGUINITY: 'データの血族関係',
			TIME_FRAME_TITLE: '時間枠を設定。',
			TIME_FRAME_KIND: '時間枠の種類:',
			TIME_FRAME_KIND_NONE: '非時間枠関連',
			TIME_FRAME_KIND_YEAR: '年',
			TIME_FRAME_KIND_HALF_YEAR: '半年',
			TIME_FRAME_KIND_QUARTER: '四半期',
			TIME_FRAME_KIND_MONTH: '月',
			TIME_FRAME_KIND_WEEK_OF_YEAR: '週',
			TIME_FRAME_KIND_DAY_OF_MONTH: '日、月によって',
			TIME_FRAME_KIND_DAY_OF_WEEK: '日、週単位',
			TIME_FRAME_KIND_LAST_N_YEARS: '過去n年間',
			TIME_FRAME_KIND_LAST_N_MONTHS: '過去nか月',
			TIME_FRAME_KIND_LAST_N_WEEKS: '過去n週間',
			TIME_FRAME_KIND_LAST_N_DAYS: '過去n日間',
			TIME_FRAME_N_IS: 'N =:',
			TIME_FRAME_TILL: 'までの時間枠:',
			TIME_FRAME_TILL_NOW: '現在の時刻',
			TIME_FRAME_TILL_LAST_COMPLETE_CYCLE: '最後の完全なサイクル',
			TIME_FRAME_TILL_SPECIFIED: '日付を指定',
			TIME_FRAME_TILL_SPECIFIED_AT: 'で:',
			TIME_FRAME_TILL_SPECIFIED_AT_DESC: 'これは、指定したタイム ウィンドウの最終日で、指定した日からウィンドウを前方に推定します。',
			TIME_FRAME_CALCULATED: '現在の時間枠:',
			TIME_FRAME_PREVIOUS_CYCLE: '前の時間枠:',
			TIME_FRAME_CHAIN_CYCLE: '前のサイクルの同じ時間枠:',
			VARIABLES_TITLE: '変数の定義。',
			VARIABLE_IS: 'は',
			VARIABLE_KIND_SINGLE_VALUE: '定数値',
			VARIABLE_KIND_RANGE: '範囲の値',
			VARIABLE_KIND_BUCKET: 'バケットセグメント',
			VARIABLE_RANGE_TO: '..',
			VARIABLE_RANGE_INCLUDE_MIN: '[',
			VARIABLE_RANGE_NOT_INCLUDE_MIN: '(',
			VARIABLE_RANGE_INCLUDE_MAX: ']',
			VARIABLE_RANGE_NOT_INCLUDE_MAX: ')',
			VARIABLE_BUCKET_PLACEHOLDER: 'バケット...',
			VARIABLE_BUCKET_INCORRECT_SELECTED: '配置できないバケット。',
			VARIABLE_BUCKET_NO_AVAILABLE: '選択可能なバケットはありません。',
			VARIABLE_BUCKET_SEGMENT_PLACEHOLDER: 'セグメント...',
			VARIABLE_BUCKET_SELECT_FIRST: 'まずはバケットを選択してください。',
			VARIABLE_BUCKET_SEGMENT_INCORRECT_SELECTED: '配置できないセグメント。',
			VARIABLE_BUCKET_SEGMENT_NO_AVAILABLE: '選択可能なセグメントはありません。',
			ADD_VARIABLE: '新しい変数を追加',
			REMOVE_VARIABLE: '変数を削除',
			FACTORS_TITLE: '指標の構成。',
			FACTOR_INDICATOR: '指標',
			FACTOR_INDICATOR_FILTER: 'フィルタ',
			FACTOR_FORMULA: '計算方法',
			FACTOR_REFER_SELF: '自分',
			REFER_INDICATOR_PLACEHOLDER: '指標...',
			REFER_INDICATOR_BUT_INCORRECT: '配置できない指標。',
			REFER_INDICATOR_BUT_NO_AVAILABLE: '選択可能な指標はありません。',
			REFER_INDICATOR_BUT_NOT_READY: '今設定することはできません、最初に指標を選択してください。',
			REFER_INDICATOR_ON_NO_FILTER: 'すべてのデータ',
			REFER_INDICATOR_ON_TOPIC_FILTER_PLACEHOLDER: 'ファクター...',
			REFER_INDICATOR_ON_SUBJECT_FILTER_PLACEHOLDER: 'カラム...',
			REFER_INDICATOR_FILTER_ON_INCORRECT_FACTOR_OR_COLUMN: 'ターゲットにできない選択',
			REFER_INDICATOR_FILTER_NO_AVAILABLE_FACTOR_OR_COLUMN: 'オプションはありません。',
			REFER_INDICATOR_FILTER_ON_INCORRECT_BUCKET: '配置できないバケット。',
			REFER_INDICATOR_FILTER_NO_AVAILABLE_BUCKET: '選択可能なバケットはありません。',
			REFER_INDICATOR_FILTER_BUCKET_PLACEHOLDER: 'バケット...',
			REFER_INDICATOR_FILTER_BUCKET_FIRST: 'まずはバケットを選択してください。',
			REFER_INDICATOR_FILTER_NO_AVAILABLE_BUCKET_SEGMENT: '選択可能なセグメントはありません。',
			REFER_INDICATOR_FILTER_BUCKET_SEGMENT_PLACEHOLDER: 'セグメント...',
			ADD_INDICATOR: '指標を追加',
			ADD_COMPUTED_INDICATOR: '計算指標を追加',
			NOT_NOW: '捨てる',
			SAVE_OBJECTIVE: '目標を保存',
			SAVE_NAME: '名前を保存',
			REQUIRE_OBJECTIVE_NAME: '読み取りには目標名が必要です。',
			CHANGE_NAME: '名前を変更',
			NAME_TITLE: '読むための名前を入力してください。',
			DESCRIPTION_TITLE: '説明。',
			USER_GROUP_TITLE: 'ユーザーグループに付与します。',
			GRANT_USER_GROUP: 'アクセス権の付与',
			REFER_FACTOR_PLACEHOLDER: '指標...',
			REFER_FACTOR_BUT_NONAME: '名前なし指標',
			REFER_FACTOR_BUT_INCORRECT: '配置できない指標。',
			REFER_FACTOR_BUT_NO_AVAILABLE: '選択可能な指標はありません。',
			ADD_SUB_PARAMETER: 'パラメータを追加',
			CANNOT_ADD_COMPUTATION_PARAMETER: 'パラメータの最大数に達しており、追加できません。',
			CANNOT_DELETE_COMPUTATION_PARAMETER: 'パラメータの最小数に達しており、削除できません。',
			EXPRESSION: '式',
			ADD_SUB_EXPRESSION: 'フィルタの条件を追加',
			ADD_SUB_JOINT: 'サブ結合を追加',
			TEST_FACTOR: '指標値',
			TEST_VALUE_CLICK: 'クリックして値を取得',
			TEST_VALUE_GET_NONE: 'データが取得されない。'
		},
		CONVERGENCE: {
			LIST_TITLE: '収束',
			LIST_CREATE_CONVERGENCE: '収束を作成',
			LIST_LABEL: '収束',
			NEW_CONVERGENCE_PREFIX: '新しい',
			EXISTING_CONVERGENCE_PREFIX: '既存',
			CREATE_AT: '作成先',
			LAST_MODIFIED_AT: '最終更新日',
			FAILED_TO_LOAD_CONVERGENCE: '収束データの読み込みにエラーが発生しました。詳細については、管理者に問い合わせてください。',
			TITLE: '収束を準備',
			BACK_TO_LIST: 'リストに戻り',
			DEF_TITLE: '定義。',
			VARIABLE_NAME: '名前',
			VARIABLE_TYPE_FREE_WALK: '無料定義',
			VARIABLE_FREE_WALK_SEGMENTS: 'セグメント',
			VARIABLE_TYPE_BUCKET: 'バケット',
			VARIABLE_BUCKET: 'バケット',
			VARIABLE_BUCKET_SEGMENTS: 'セグメント',
			VARIABLE_TYPE_TIMEFRAME: '時間枠',
			VARIABLE_TIMEFRAME_KIND: 'サイクル',
			VARIABLE_TIMEFRAME_TILL: 'までの時間枠',
			VARIABLE_TIMEFRAME_TIMES: '周波数',
			VARIABLE_TIMEFRAME_KIND_DAY: '毎日',
			VARIABLE_TIMEFRAME_KIND_WEEK: '毎週',
			VARIABLE_TIMEFRAME_KIND_MONTH: '毎月',
			VARIABLE_TIMEFRAME_KIND_QUARTER: '季刊',
			VARIABLE_TIMEFRAME_KIND_HALFYEAR: '半年ごと',
			VARIABLE_TIMEFRAME_KIND_YEAR: '毎年',
			X_AXIS_ADD_PLACEHOLDER: '横軸に次元を追加',
			Y_AXIS_ADD_PLACEHOLDER: '縦軸に次元を追加',
			PLEASE_SELECT_TARGET: '...を選択してください',
			TARGET_USE_TIME_FRAME: '時間枠を使用？',
			VARIABLE_MAPPING_IGNORED: '無視され',
			VARIABLE_MAPPING_SOURCE_PLACEHOLDER: '...を選択してください',
			FREEZE_DEF: '次元をロック',
			UNFREEZE_DEF: '次元のロック解除',
			VARIABLE_NOT_FILLED: '定義された軸の凡例の属性値が正しく入力されているか確認してください。',
			ASK_VALUES: '定義完了、データをリクエストしてください',
			BACK_TO_DEF: '定義に戻る',
			CHANGE_NAME: '名前を変更',
			NAME_TITLE: '読むための名前を入力してください。',
			DESCRIPTION_TITLE: '説明。',
			USER_GROUP_TITLE: 'ユーザーグループに付与します。',
			GRANT_USER_GROUP: 'アクセス権の付与'
		}
	},
	SUBSCRIBE: {
		ON: '電子メールボックスを購読する。',
		BY_MAIL: '電子メール',
		MAIL_ADDRESS: 'アドレス',
		BY_SLACK: 'Slack',
		SLACK_CHANNEL: 'Slackチャンネル',
		FREQUENCY: 'サイクル',
		DAILY: '毎日',
		WEEKLY: '毎週',
		MONTHLY: '毎月',
		SUBSCRIPTION_SUBMITTED: 'サブスクリプションが正常に送信されました。'
	},
	SETTINGS: {
		TITLE: '設定',
		LANGUAGE: '言語',
		THEME: 'テーマ',
		THEME_LIGHT: '標準',
		THEME_LIGHT_CONTRAST_BIGGER: '高コントラスト、大きなフォント',
		THEME_DARK: 'ダーク',
		THEME_DARK_CONTRAST_BIGGER: 'ダーク、高コントラスト、大きなフォント',
		PAT: {
			TITLE: 'パーソナルアクセストークン',
			CREATE: '新しいトークンを生成する',
			DESCRIPTION: 'Watchmen APIへのアクセスに使用できる生成したトークン。',
			DELETE_CONFIRM: 'トークンを削除してもよろしいですか？ 削除したものは復元できませんので、ご注意ください。',
			INPUT_PLACEHOLDER: 'トークンの目的を特定するためのメモ',
			NOTE_REQUIRED: 'トークンには注意が必要です。'
		}
	},
	PARAM: {
		FROM: 'から',
		FROM_TOPIC: 'トピック',
		FROM_CONSTANT: '定数値',
		FROM_COMPUTED: '計算',
		FROM_INDICATOR: '指標参照',
		FROM_BUCKET: 'バケット',
		FROM_TIME_FRAME: '時間枠'
	},
	FACTOR: {
		SEQUENCE: 'シーケンス',
		NUMBER: '数値',
		UNSIGNED: '符号なし数値',
		TEXT: 'テキスト',
		ADDRESS: 'アドレス',
		CONTINENT: '大陸',
		REGION: '地域',
		COUNTRY: '国',
		PROVINCE: '州/省',
		CITY: '市',
		DISTRICT: '区',
		ROAD: '道',
		COMMUNITY: 'コミュニティ',
		FLOOR: '階',
		RESIDENCE_TYPE: '住宅タイプ',
		RESIDENTIAL_AREA: '住宅面積',
		EMAIL: 'メール',
		PHONE: '電話番号',
		MOBILE: '携帯番号',
		FAX: 'ファックス',
		DATETIME: '日付時刻',
		FULL_DATETIME: '日付(ミリ秒)',
		DATE: '日付',
		TIME: '時刻',
		YEAR: '年',
		HALF_YEAR: '上半期/下半期',
		QUARTER: '四半期',
		MONTH: '月',
		HALF_MONTH: '月の上半期/月の下半期',
		TEN_DAYS: '上旬/中旬/下旬',
		WEEK_OF_YEAR: '年の週',
		WEEK_OF_MONTH: '月の週',
		HALF_WEEK: '週の上半期/週の下半期',
		DAY_OF_MONTH: '月の日',
		DAY_OF_WEEK: '週の日',
		DAY_KIND: '勤務日/週末/祝日',
		HOUR: '時間',
		HOUR_KIND: '勤務時間/勤務時間外/睡眠時間',
		MINUTE: '分',
		SECOND: '秒',
		MILLISECOND: 'ミリ秒',
		AM_PM: '午前/午後',
		GENDER: '性別',
		OCCUPATION: '職業',
		DATE_OF_BIRTH: '生年月日',
		AGE: '年齢',
		ID_NO: 'ID',
		RELIGION: '宗教',
		NATIONALITY: '国籍',
		BIZ_TRADE: '業界',
		BIZ_SCALE: '規模',
		BOOLEAN: 'ブール値',
		ENUM: '列挙',
		OBJECT: 'オブジェクト',
		ARRAY: 'アレイ'
	},
	PARAMETER: {
		EXPRESSION: '式',
		COMPUTE_TYPE: {
			NONE: 'As is',
			ADD: 'たす',
			SUBTRACT: 'ひく',
			MULTIPLY: 'かける',
			DIVIDE: 'わる',
			MODULUS: 'モジュロ',
			YEAR_OF: '年',
			HALF_YEAR_OF: '上半期/下半期',
			QUARTER_OF: '四半期',
			MONTH_OF: '月',
			WEEK_OF_YEAR: '年の週',
			WEEK_OF_MONTH: '月の週',
			DAY_OF_MONTH: '月の日',
			DAY_OF_WEEK: '週の日',
			CASE_THEN: 'ケース',
			ROUND: 'Round',
			ROUND_DIGITS: '数値の桁数',
			FLOOR: 'Floor',
			CEIL: 'Ceil',
			ABS: '絶対値',
			MAX: '最大値',
			MIN: '最小値',
			INTERPOLATE: '線形補間',
			INTERPOLATE_MIN_VALUE: '下の境界値',
			INTERPOLATE_MIN_VALUE_TO: '下境界マップ値',
			INTERPOLATE_MAX_VALUE: '上境界値',
			INTERPOLATE_MAX_VALUE_TO: '上境界マップ値'
		},
		EXPRESSION_OPERATOR: {
			EMPTY: '空',
			NOT_EMPTY: '値がある',
			EQUALS: 'イコール',
			NOT_EQUALS: '不等',
			LESS: '未満',
			LESS_EQUALS: '以下',
			MORE: '超',
			MORE_EQUALS: '以上',
			IN: 'In',
			NOT_IN: 'Not In'
		}
	},
	JOINT: {
		AND: 'And',
		OR: 'OR'
	},
	JOIN: {
		INNER: '完全に一致',
		LEFT: '左側優先',
		RIGHT: '右側優先'
	},
	FUNNEL: {
		COLUMN: 'カラム - タイプ',
		RANGE: '範囲？',
		ENABLED: '有効？',
		NUMERIC: '数値',
		DATE: '日付',
		YEAR: '年',
		HALF_YEAR: '半年',
		QUARTER: '四半期',
		MONTH: '月',
		HALF_MONTH: '上と下の月',
		TEN_DAYS: '上中下旬',
		WEEK_OF_MONTH: '月の週',
		HALF_WEEK: '上と下の週',
		DAY_KIND: '平日/週末/休日',
		DAY_OF_WEEK: '月の日',
		HOUR: '時間',
		HOUR_KIND: '期間',
		AM_PM: '上の午後',
		ENUM: '列挙'
	},
	PAGINATION: {
		TOTAL: '合計',
		ROWS: '行',
		OF_PAGES: '/',
		PAGES: 'ページ'
	},
	CHART: {
		SETTINGS_HEADER_LABEL: 'レポート設定',
		SECTION_TITLE_BASIC_STYLE: '基本スタイル',
		SECTION_TITLE_DIMENSIONS: 'ディメンション',
		SECTION_TITLE_INDICATORS: '指標',
		SECTION_TITLE_BASIC: '基本',
		SECTION_TITLE_PALETTE_SIZE: 'パレットサイズ',
		SECTION_TITLE_COLOR: '色を塗る',
		SECTION_TITLE_BORDER: 'ボーダー',
		SECTION_TITLE_FONT: 'フォント',
		SECTION_TITLE_POSITION: '位置',
		SECTION_TITLE_PADDING: '余白',
		SECTION_TITLE_GAP_AND_PADDING: '間隔、余白',
		SECTION_TITLE_VALUE_FORMAT: '値形式',
		SECTION_TITLE_FUNNEL_DEFINITION: 'じょうご定義',
		DIMENSIONS: 'ディメンション',
		INDICATORS: '指標',
		FILTERS: 'フィルタ',
		NO_FUNNEL_DETECTED: '使用可能なじょうごは検出されていません。',
		FUNNEL_DESCRIPTION: '利用可能なじょうごは自動的に検出され、レポートデータをこことダッシュボードで動的に調整できます。',
		FUNNEL_INSTANCE_DESCRIPTION: 'パレットを開いてじょうごの値を定義します。',
		DESCRIPTION: '説明',
		WIDTH: '幅',
		HEIGHT: '高さ',
		PIXEL: 'PX',
		PERCENTAGE: '%',
		DEGREE: '度',
		LINE_COLOR: '線の色',
		LINE_STYLE: '線のスタイル',
		FONT_FAMILY: 'フォント',
		FONT_COLOR: 'フォントの色',
		FONT_SIZE: 'フォントのサイズ',
		FONT_STYLE: 'フォントのスタイル',
		FONT_STYLE_NORMAL: '標準',
		FONT_STYLE_ITALIC: 'イタリック',
		FONT_WEIGHT: 'フォントの太さ',
		FONT_WEIGHT_100: '100',
		FONT_WEIGHT_200: '200',
		FONT_WEIGHT_300: '300',
		FONT_WEIGHT_400: '400',
		FONT_WEIGHT_500: '500',
		FONT_WEIGHT_600: '600',
		FONT_WEIGHT_700: '700',
		FONT_WEIGHT_800: '800',
		FONT_WEIGHT_900: '900',
		BACKGROUND_COLOR: '背景色',
		BORDER_STYLE: 'ボーダースタイル',
		BORDER_STYLE_NONE: 'なし',
		BORDER_STYLE_SOLID: 'ソリッド',
		BORDER_STYLE_DASHED: '破線',
		BORDER_STYLE_DOTTED: '点線',
		BORDER_COLOR: 'ボーダー色',
		BORDER_WIDTH: 'ボーダー幅',
		BORDER_RADIUS: 'ボーダー半径',
		POSITION: 'ポジション',
		POSITION_ON_OUTSIDE_OF_PIE: '外側の位置',
		POSITION_TOP: '上側',
		POSITION_RIGHT: '右側',
		POSITION_LEFT: '左側',
		POSITION_BOTTOM: '下側',
		HORIZONTAL_ALIGNMENT: '水平方向に整列',
		HORIZONTAL_ALIGNMENT_AUTO: 'オート',
		HORIZONTAL_ALIGNMENT_LEFT: '左揃え',
		HORIZONTAL_ALIGNMENT_CENTER: '中央揃え',
		HORIZONTAL_ALIGNMENT_RIGHT: '右揃え',
		VERTICAL_ALIGNMENT: '垂直方向に整列',
		VERTICAL_ALIGNMENT_AUTO: 'オート',
		VERTICAL_ALIGNMENT_TOP: '上揃え',
		VERTICAL_ALIGNMENT_MIDDLE: '中央揃え',
		VERTICAL_ALIGNMENT_BOTTOM: '下揃え',
		TITLE_TEXT_ITEM_GAP: 'タイトルの間隔',
		PADDING: '余白',
		SHOW: '表示',
		SERIES_TEXT_SHOW: 'シリーズテキストを表示',
		SERIES_TEXT_POSITION: 'シリーズテキスト - 位置',
		SERIES_TEXT_FONT: 'シリーズテキスト - フォント',
		SERIES_TEXT_COLOR: 'シリーズテキスト - 色を塗る',
		SERIES_TEXT_BORDER: 'シリーズテキスト - ボーダー',
		SERIES_TEXT_GAP_AND_PADDING: 'シリーズテキスト - 間隔、余白',
		LEGEND_ORIENT: '方向',
		LEGEND_ORIENT_HORIZONTAL: '水平',
		LEGEND_ORIENT_VERTICAL: '垂直',
		GRID_CONTAIN_LABEL: 'コンテナラベル',
		AXIS_TYPE: '軸タイプ',
		AXIS_TYPE_CATEGORY: '分類',
		AXIS_TYPE_VALUE: '値',
		AXIS_TYPE_TIME: '時間',
		AXIS_AUTO_MIN: '（オート）最小値',
		AXIS_MIN: '最小値',
		AXIS_AUTO_MAX: '（オート）最大値',
		AXIS_MAX: '最大値',
		AXIS_NAME_LOCATION: 'ロケーション',
		AXIS_NAME_LOCATION_START: '開始',
		AXIS_NAME_LOCATION_CENTER: '中央',
		AXIS_NAME_LOCATION_END: '末尾',
		AXIS_NAME_GAP: '間隔',
		AXIS_NAME_ROTATE: '回転度',
		AXIS_LABEL_INSIDE: '内側',
		LABEL_GAP: '間隔',
		LABEL_ROTATE: '回転度',
		LABEL_FORMAT_USING_GROUP: '小数第3位',
		LABEL_FORMAT_USING_PERCENTAGE: '%を追加する',
		LABEL_VALUE_AS_PERCENTAGE: '値を%に変換する',
		LABEL_FRACTION_DIGITS: '小数位',
		LABEL_POSITION_TOP: '上側',
		LABEL_POSITION_LEFT: '左側',
		LABEL_POSITION_RIGHT: '右側',
		LABEL_POSITION_BOTTOM: '下側',
		LABEL_POSITION_INSIDE: '内部',
		LABEL_POSITION_INSIDE_LEFT: '内部の左側',
		LABEL_POSITION_INSIDE_RIGHT: '内部の右側',
		LABEL_POSITION_INSIDE_TOP: '内部の上側',
		LABEL_POSITION_INSIDE_BOTTOM: '内部の下側',
		LABEL_POSITION_INSIDE_TOP_LEFT: '内部の左上側',
		LABEL_POSITION_INSIDE_BOTTOM_LEFT: '内部の左下側',
		LABEL_POSITION_INSIDE_TOP_RIGHT: '内部の右上側',
		LABEL_POSITION_INSIDE_BOTTOM_RIGHT: '内部の右下側',
		LABEL_POSITION_OUTSIDE: '外部',
		LABEL_POSITION_CENTER: '中央',
		DECAL: 'デカール',
		ROAM: 'ローミング',
		TREE_LAYOUT: 'レーアウト',
		TREE_LAYOUT_ORTHOGONAL: '直交',
		TREE_LAYOUT_RADIAL: 'ラジアル',
		TREE_ORIENT: '方向',
		TREE_ORIENT_LEFT_RIGHT: '左から右へ',
		TREE_ORIENT_RIGHT_LEFT: '右から左へ',
		TREE_ORIENT_TOP_BOTTOM: '上から下へ',
		TREE_ORIENT_BOTTOM_TOP: '下から上へ',
		PIE_CENTER_X: '中央X',
		PIE_CENTER_Y: '中央Y',
		PIE_INSIDE_RADIUS: '内側の半径',
		PIE_OUTSIDE_RADIUS: '外側の半径',
		PIE_ROSE_TYPE: 'ローズ',
		PIE_ROSE_TYPE_NONE: 'なし',
		PIE_ROSE_TYPE_RADIUS: '半径により',
		PIE_ROSE_TYPE_AREA: '面積により',
		PIE_SHOW_PERCENTAGE: '%表示',
		PIE_LABEL_ALIGN_TO_NONE: 'なし',
		PIE_LABEL_ALIGN_TO_LABEL_LINE: 'ラベルライン',
		PIE_LABEL_ALIGN_TO_EDGE: '縁',
		MAP_REGION: '地域',
		MAP_REGION_CHINA_L1: '中国 (省)',
		MAP_REGION_CYPRUS_L1: 'キプロス',
		MAP_REGION_JAPAN_L1: '日本 (県/都/府)',
		MAP_REGION_SINGAPORE_L1: 'シンガポール',
		MAP_REGION_USA_L1: '米国 (州)',
		TRUNCATION_TYPE: 'タイプ',
		TRUNCATION_NONE: 'なし',
		TRUNCATION_TOP: '最高',
		TRUNCATION_BOTTOM: '最低',
		TRUNCATION_COUNT: '数量',
		BAR_TRANSFORM_AXIS: '軸の変換',
		LINE_SMOOTH: 'スムーズ',
		TOOLBOX_ORIENT: '方向',
		TOOLBOX_ORIENT_HORIZONTAL: '水平',
		TOOLBOX_ORIENT_VERTICAL: '垂直',
		SECTION_TITLE_COUNT_CHART: '特定スタイル',
		SECTION_TITLE_BAR_CHART: 'バー/ラインスタイル',
		SECTION_TITLE_PIE_CHART: 'パイスタイル',
		SECTION_TITLE_TREE_CHART: 'ツリースタイル',
		SECTION_TITLE_TREEMAP_CHART: 'ツリーマップスタイル',
		SECTION_TITLE_MAP_CHART: '地図スタイル',
		SECTION_TITLE_ECHART_TITLE: 'タイトル',
		SECTION_TITLE_ECHART_SUBTITLE: 'サブタイトル',
		SECTION_TITLE_ECHART_LEGEND: '凡例',
		SECTION_TITLE_ECHART_GRID: 'グリッド',
		SECTION_TITLE_ECHART_XAXIS: 'X軸',
		SECTION_TITLE_ECHART_XAXIS_RANGE: 'X軸の範囲',
		SECTION_TITLE_ECHART_XAXIS_NAME: 'X軸の名称',
		SECTION_TITLE_ECHART_XAXIS_NAME_FONT: 'X軸の名称 - フォント',
		SECTION_TITLE_ECHART_XAXIS_NAME_COLOR: 'X軸の名称 - 色を塗る',
		SECTION_TITLE_ECHART_XAXIS_NAME_BORDER: 'X軸の名称 - ボーダー',
		SECTION_TITLE_ECHART_XAXIS_NAME_GAP_AND_PADDING: 'X軸の名称 - 間隔、余白',
		SECTION_TITLE_ECHART_XAXIS_LABEL: 'X軸のレベル',
		SECTION_TITLE_ECHART_XAXIS_LABEL_FONT: 'X軸のレベル - フォント',
		SECTION_TITLE_ECHART_XAXIS_LABEL_COLOR: 'X軸のレベル - 色を塗る',
		SECTION_TITLE_ECHART_XAXIS_LABEL_BORDER: 'X軸のレベル - ボーダー',
		SECTION_TITLE_ECHART_XAXIS_LABEL_GAP_AND_PADDING: '横轴标签 - 間隔、余白',
		SECTION_TITLE_ECHART_XAXIS_LINE: 'X軸の分割線',
		SECTION_TITLE_ECHART_XAXIS_MINOR_LINE: 'X軸のマイナー分割線',
		SECTION_TITLE_ECHART_YAXIS: 'Y軸',
		SECTION_TITLE_ECHART_YAXIS_RANGE: 'Y軸の範囲',
		SECTION_TITLE_ECHART_YAXIS_NAME: 'Y軸の名称',
		SECTION_TITLE_ECHART_YAXIS_NAME_FONT: 'Y軸の名称 - フォント',
		SECTION_TITLE_ECHART_YAXIS_NAME_COLOR: 'Y軸の名称 - 色を塗る',
		SECTION_TITLE_ECHART_YAXIS_NAME_BORDER: 'Y軸の名称 - ボーダー',
		SECTION_TITLE_ECHART_YAXIS_NAME_GAP_AND_PADDING: 'Y軸の名称 - 間隔、余白',
		SECTION_TITLE_ECHART_YAXIS_LABEL: 'Y軸のレベル',
		SECTION_TITLE_ECHART_YAXIS_LABEL_FONT: 'Y軸のレベル - フォント',
		SECTION_TITLE_ECHART_YAXIS_LABEL_COLOR: 'Y軸のレベル - 色を塗る',
		SECTION_TITLE_ECHART_YAXIS_LABEL_BORDER: 'Y軸のレベル - ボーダー',
		SECTION_TITLE_ECHART_YAXIS_LABEL_GAP_AND_PADDING: 'Y軸のレベル - 間隔、余白',
		SECTION_TITLE_ECHART_YAXIS_LINE: 'Y軸の分割線',
		SECTION_TITLE_ECHART_YAXIS_MINOR_LINE: 'Y軸のマイナー分割線',
		SECTION_TITLE_ECHART_SCRIPT: 'スクリプト',
		SECTION_TITLE_ECHART_SCRIPT_VARS_DEF: '変数の定義',
		SECTION_TITLE_ECHART_SCRIPT_VARS: '変数',
		SECTION_TITLE_TRUNCATION: 'データの切り捨て',
		SECTION_TITLE_TOOLBOX: 'ツールボックス',
		NONAME_COLUMN: 'ノーネームカラム',
		UNKNOWN_COLUMN_NAME: '不明なカラム',
		CAN_NOT_DELETE_DIMENSION: 'ディメンションの最小限に達したため、削除できません。',
		CAN_NOT_ADD_DIMENSION: 'ディメンションの最大限に達したため、これ以上追加できません。',
		CAN_NOT_DELETE_INDICATOR: '指標の最小限に達したため、削除できません。',
		CAN_NOT_ADD_INDICATOR: '指標の最大限に達したため、これ以上追加できません。',
		ADD_DIMENSION: 'ディメンションを追加する',
		ADD_INDICATOR: '指標を追加する',
		PLEASE_SELECT_DIMENSION: '...を選択してください',
		PLEASE_SELECT_INDICATOR: '...を選択してください',
		PLEASE_SELECT_FUNNEL_VALUE: '...を選択してください',
		NO_ENUM_FUNNEL_VALUE: '選択値がありません。',
		NO_SCRIPT_VARS: '変数定義はありません。',
		ARITHMETIC_NONE: 'そのまま',
		ARITHMETIC_SUMMARY: '合計',
		ARITHMETIC_AVERAGE: '平均値',
		ARITHMETIC_COUNT: '数量',
		ARITHMETIC_DISTINCT_COUNT: '合計数の重複排除',
		ARITHMETIC_MAX: '最大値',
		ARITHMETIC_MIN: '最小値',
		TYPE: 'タイプ',
		TYPES: {
			COUNT: '数値統計グラフ',
			BAR: 'ヒストグラム',
			LINE: '折れ線グラフ',
			SCATTER: '散布図',
			PIE: '円グラフ',
			DOUGHNUT: 'ドーナツグラフ',
			NIGHTINGALE: 'ナイチンゲールグラフ',
			SUNBURST: 'サンバースト図',
			TREE: '樹形図',
			TREEMAP: 'ツリーマップ',
			MAP: 'マップ',
			CUSTOMIZED: 'カスタマイズ'
		},
		COUNT: {
			FORMAT_USING_GROUP: '小数第3位'
		},
		ECHART: {
			TEXT: 'テキスト'
		},
		DEFINITION_BROKEN: '定義はまだ完了していませんが、現時点ではグラフをレンダリングできません。'
	},
	MEASURE_METHOD: {
		CONTINENT: '大陸',
		REGION: '地域',
		COUNTRY: '国',
		PROVINCE: '州/省',
		CITY: '市',
		DISTRICT: '区',
		FLOOR: '階',
		RESIDENCE_TYPE: '住宅タイプ',
		RESIDENTIAL_AREA: '住宅面積',
		YEAR: '年',
		HALF_YEAR: '上半期/下半期',
		QUARTER: '四半期',
		MONTH: '月',
		HALF_MONTH: '月の上半期/月の下半期',
		TEN_DAYS: '上旬/中旬/下旬',
		WEEK_OF_YEAR: '年の週',
		WEEK_OF_MONTH: '月の週',
		HALF_WEEK: '週の上半期/週の下半期',
		DAY_OF_MONTH: '月の日',
		DAY_OF_WEEK: '週の日',
		DAY_KIND: '勤務日/週末/祝日',
		HOUR: '時間',
		HOUR_KIND: '勤務時間/勤務時間外/睡眠時間',
		AM_PM: '午前/午後',
		GENDER: '性別',
		OCCUPATION: '職業',
		AGE: '年齢',
		RELIGION: '宗教',
		NATIONALITY: '国籍',
		BIZ_TRADE: '業界',
		BIZ_SCALE: '規模',
		BOOLEAN: 'ブール値',
		ENUM: '列挙'
	},
	RELEVANT_INDICATOR_TYPE: {
		SAME: '同じ',
		HIGH_CORRELATED: '高い関連性',
		WEAK_CORRELATED: '弱い関連性',
		THIS_CAUSES_RELEVANT: '現在の指標は、関連指標につながります',
		RELEVANT_CAUSES_THIS: '関連指標は、現在の指標につながります'
	},
	SHARE: {
		NOTHING: '内容が見つかりません。詳細については、管理者にお問い合わせください。'
	},
	CALENDAR: {
		JAN: '1月',
		FEB: '2月',
		MAR: '3月',
		APR: '4月',
		MAY: '5月',
		JUN: '6月',
		JUL: '7月',
		AUG: '8月',
		SEP: '9月',
		OCT: '10月',
		NOV: '11月',
		DEC: '12月',
		WEEK: '週',
		WEEK_0: '第0週 (7日未満)',
		WEEK_1: '第1週',
		WEEK_2: '第2週',
		WEEK_3: '第3週',
		WEEK_4: '第4週',
		WEEK_5: '第5週 (7日未満)',
		HALF_YEAR_1ST: '上半期',
		HALF_YEAR_2ND: '下半期',
		QUARTER_1ST: '第1四半期',
		QUARTER_2ND: '第2四半期',
		QUARTER_3RD: '第3四半期',
		QUARTER_4TH: '第4四半期',
		HALF_MONTH_1ST: '先月の前半',
		HALF_MONTH_2ND: '後半の月',
		TEN_DAYS_1ST: '上旬',
		TEN_DAYS_2ND: '中旬',
		TEN_DAYS_3RD: '下旬',
		HALF_WEEK_1ST: '上半週',
		HALF_WEEK_2ND: '後半',
		SUNDAY: '日曜日',
		MONDAY: '月曜日',
		TUESDAY: '火曜日',
		WEDNESDAY: '水曜日',
		THURSDAY: '木曜日',
		FRIDAY: '金曜日',
		SATURDAY: '土曜日',
		WORKDAY: '平日',
		WEEKEND: '週末',
		HOLIDAY: '休日',
		WORK_TIME: '勤務時間',
		OFF_HOURS: '暇な時',
		SLEEPING_TIME: '睡眠時間',
		AM: '朝',
		PM: '午後'
	},
	CONSANGUINITY: {
		OBJECTIVE_TARGET_BLOCK_LABEL: '目標',
		OBJECTIVE_FACTOR_BLOCK_LABEL: '測定方法',
		INDICATOR_BLOCK_LABEL: '指標',
		SUBJECT_BLOCK_LABEL: '主題',
		REPORT_BLOCK_LABEL: 'フィルタ',
		TOPIC_BLOCK_LABEL: 'トピック',
		BUCKET_BLOCK_LABEL: 'バケット',
		ENUM_BLOCK_LABEL: '列挙',
		NO_OBJECTIVE_TARGET_FOUND: '目標定義が見つかりませんでした。',
		NONAME_OBJECTIVE_TARGET: '名前のない目標',
		NONAME_OBJECTIVE_FACTOR: '名前のない測定方法',
		NONAME_INDICATOR: '名前のない指標',
		NONAME_SUBJECT: '名前のない主題',
		NONAME_SUBJECT_COLUMN: '名前のない列',
		NONAME_REPORT: '名前のないフィルタ',
		NONAME_TOPIC: '名前のないトピック',
		NONAME_TOPIC_FACTOR: '名前のないファクター',
		NONAME_BUCKET: '名前のないバケット',
		NONAME_ENUM: '名前のない列挙'
	}
};